module.exports = __webpack_public_path__ + "static/img/bg.781a99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/bg.png
// module id = Vau/
// module chunks = 44